import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CandidatePipeline = ({ candidates }) => {
  const getStageColor = (stage) => {
    switch (stage) {
      case 'approved': return 'success';
      case 'interview_scheduled': return 'secondary';
      case 'pending_review': return 'warning';
      case 'onboarding': return 'accent';
      case 'rejected': return 'error';
      default: return 'muted';
    }
  };

  const getVeteranStatusColor = (status) => {
    switch (status) {
      case 'verified': return 'success';
      case 'pending_verification': return 'warning';
      case 'failed': return 'error';
      default: return 'muted';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="glass-container rounded-xl border border-border/50">
      <div className="p-6 border-b border-border/50">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Candidate Pipeline</h3>
            <p className="text-sm text-muted-foreground mt-1">
              {candidates?.length || 0} candidates in pipeline
            </p>
          </div>
          <Button variant="ghost" size="sm" iconName="Filter">
            Filter
          </Button>
        </div>
      </div>
      <div className="divide-y divide-border/50">
        {candidates?.map((candidate) => (
          <div
            key={candidate?.id}
            className="p-6 hover:bg-white/5 transition-colors duration-200"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
                  <Icon name="User" size={20} color="white" />
                </div>
                <div>
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-semibold text-foreground">{candidate?.name}</h4>
                    <span className={`px-2 py-1 rounded text-xs font-medium text-${getStageColor(candidate?.applicationStage)} bg-${getStageColor(candidate?.applicationStage)}/10`}>
                      {candidate?.applicationStage?.replace('_', ' ')?.toUpperCase()}
                    </span>
                    <span className={`px-2 py-1 rounded text-xs font-medium text-${getVeteranStatusColor(candidate?.veteranStatus)} bg-${getVeteranStatusColor(candidate?.veteranStatus)}/10`}>
                      {candidate?.veteranStatus?.replace('_', ' ')?.toUpperCase()}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground mb-2">{candidate?.email}</p>
                  <div className="flex items-center space-x-4 text-sm text-muted-foreground mb-3">
                    <div className="flex items-center space-x-1">
                      <Icon name="Shield" size={14} />
                      <span>{candidate?.militaryBranch}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Icon name="Award" size={14} />
                      <span>{candidate?.rank}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Icon name="Clock" size={14} />
                      <span>{candidate?.yearsOfService} years</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Icon name="Lock" size={14} />
                      <span>{candidate?.clearanceLevel}</span>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    {candidate?.skills?.slice(0, 3)?.map((skill, index) => (
                      <span
                        key={index}
                        className="px-2 py-1 rounded text-xs font-medium bg-muted/50 text-muted-foreground"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <div className="flex items-center space-x-2">
                <Button variant="ghost" size="sm" iconName="Eye">
                  View
                </Button>
                {candidate?.applicationStage === 'pending_review' && (
                  <Button variant="outline" size="sm" iconName="Calendar">
                    Schedule
                  </Button>
                )}
              </div>
            </div>

            <div className="flex items-center justify-between text-sm text-muted-foreground">
              <span>Applied: {formatDate(candidate?.applicationDate)}</span>
              {candidate?.interviewDate && (
                <span>Interview: {formatDate(candidate?.interviewDate)}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CandidatePipeline;